import { useCallback, useState } from 'react'
import { ISourcedCarrierRate } from 'types/graphqlTypes'
import { SourcedCarrierRatesQueryResult } from '../graphql/SourcedCarrierRates'

export const useEditSourcedCarrierRateModal = (
  refetch: SourcedCarrierRatesQueryResult['refetch']
) => {
  const [open, setOpen] = useState<boolean>(false)
  const [sourcedCarrierRateToEdit, setSourcedCarrierRateToEdit] = useState<ISourcedCarrierRate>()

  const closeEditSourcedCarrierRateModal = useCallback(() => {
    setOpen(false)
    setSourcedCarrierRateToEdit(sourcedCarrierRate => {
      if (!sourcedCarrierRate) {
        refetch()
      }

      return undefined
    })
  }, [refetch])

  const openEditSourcedCarrierRateModal = useCallback(
    (sourcedCarrierRate?: ISourcedCarrierRate) => {
      setSourcedCarrierRateToEdit(sourcedCarrierRate)
      setOpen(true)
    },
    []
  )

  return {
    isEditSourcedCarrierRateModalOpen: open,
    sourcedCarrierRateToEdit,
    closeEditSourcedCarrierRateModal,
    openEditSourcedCarrierRateModal,
  }
}
